module.exports = __webpack_public_path__ + "img/thermometer.6fd14bff.svg";